export default __webpack_public_path__ + "static/media/SettingsSelected.3564b3f2.svg";